(function () {
  const ROOT_SELECTOR = "[data-cart-reco]";
  const SLIDE_SELECTOR = "[data-cart-reco-product-id]";
  const CLICKED_KEY = "factory54:cart_reco_clicked";
  function displayCount(root) {
    const n = Number(root?.getAttribute?.("data-cart-reco-display") || 0);
    return Number.isFinite(n) && n > 0 ? n : 8;
  }
  const POOL_PAGES = 4;
  const FALLBACK_PAGES = 4;
  const DEFAULT_FALLBACK = "you-may-also-like-cart";

  function dataLayerPush(eventName, payload) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(Object.assign({ event: eventName }, payload));
  }

  function rootPath() {
    const root = window.Shopify?.routes?.root || "/";
    return root.endsWith("/") ? root : `${root}/`;
  }

  function parseIdList(value) {
    return String(value || "")
      .split(",")
      .map((part) => part.trim())
      .filter(Boolean);
  }

  function parseTypePools(root) {
    const pools = {};
    String(root.getAttribute("data-cart-reco-pools") || "")
      .split(",")
      .forEach((part) => {
        const trimmed = part.trim();
        const sep = trimmed.indexOf(":");
        if (sep < 1) {
          return;
        }
        const type = trimmed.slice(0, sep).trim().toLowerCase();
        const handle = trimmed.slice(sep + 1).trim();
        if (type && handle) {
          pools[type] = handle;
        }
      });
    return pools;
  }

  function collectionSectionUrl(handle, page) {
    const url = new URL(
      `${rootPath()}collections/${encodeURIComponent(handle)}`,
      window.location.origin,
    );
    url.searchParams.set("sort_by", "best-selling");
    url.searchParams.set("section_id", "cart-reco-fallback");
    if (page > 1) {
      url.searchParams.set("page", String(page));
    }
    return url.toString();
  }

  function uniqueCount(root) {
    const seen = new Set();
    root.querySelectorAll(`.swiper-wrapper ${SLIDE_SELECTOR}`).forEach((slide) => {
      const id =
        slide.getAttribute("data-cart-reco-product-id") ||
        slide.querySelector("product-card")?.getAttribute("handle");
      if (id) {
        seen.add(String(id));
      }
    });
    return seen.size;
  }

  function ingestSlides(root, doc, remaining, existing, wrappers, preferredCategory, options = {}) {
    const slides = doc.querySelectorAll(`.swiper-slide${SLIDE_SELECTOR}`);
    slides.forEach((slide) => {
      if (remaining <= 0) {
        return;
      }
      const handle = slide.querySelector("product-card")?.getAttribute("handle");
      const incomingId = slide.getAttribute("data-cart-reco-product-id");
      const category = slideCategory(slide);
      const effectiveCategory =
        options.trustCollection && preferredCategory ? preferredCategory : category;
      if (!handle || existing.has(handle) || existing.has(incomingId)) {
        return;
      }
      if (
        preferredCategory &&
        category &&
        category !== preferredCategory &&
        !options.fillToDisplay &&
        !options.trustCollection
      ) {
        return;
      }
      if (
        !categoryNeeded(root, effectiveCategory, remaining, {
          allowOverflow: !preferredCategory || options.fillToDisplay,
          fillToDisplay: options.fillToDisplay,
          allowAnyType: options.allowAnyType,
        })
      ) {
        return;
      }
      existing.add(handle);
      if (incomingId) {
        existing.add(incomingId);
      }
      wrappers.forEach((wrapper) => {
        wrapper.appendChild(slide.cloneNode(true));
      });
      remaining -= 1;
    });
    return remaining;
  }

  function productIdFromCard(card) {
    const handle = card.getAttribute("handle");
    const slide = card.closest(SLIDE_SELECTOR);
    if (slide?.getAttribute("data-cart-reco-product-id")) {
      return slide.getAttribute("data-cart-reco-product-id");
    }
    return card.getAttribute("data-product-id") || handle || "";
  }

  function rememberClick(productId, type) {
    if (!productId) {
      return;
    }
    try {
      const data = JSON.parse(sessionStorage.getItem(CLICKED_KEY) || "{}");
      data[String(productId)] = { type: type || "default", at: Date.now() };
      sessionStorage.setItem(CLICKED_KEY, JSON.stringify(data));
    } catch {
      // Ignore storage errors.
    }
  }

  function observeOnce(element, callback) {
    if (!element || element.dataset.cartRecoObserved === "true") {
      return;
    }
    element.dataset.cartRecoObserved = "true";
    if (typeof IntersectionObserver !== "function") {
      callback();
      return;
    }
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries.some((entry) => entry.isIntersecting)) {
          observer.disconnect();
          callback();
        }
      },
      { threshold: 0.25 },
    );
    observer.observe(element);
  }

  function bindAnalytics(root) {
    const type = root.getAttribute("data-cart-reco-type") || "default";

    observeOnce(root, () => {
      dataLayerPush("cart_reco_impression", {
        cart_reco_type: type,
      });
    });

    root.querySelectorAll(SLIDE_SELECTOR).forEach((slide) => {
      const productId = slide.getAttribute("data-cart-reco-product-id");
      observeOnce(slide, () => {
        dataLayerPush("cart_reco_product_impression", {
          cart_reco_type: type,
          product_id: productId,
        });
      });
    });

    if (root.dataset.cartRecoClicksBound === "true") {
      return;
    }
    root.dataset.cartRecoClicksBound = "true";
    root.addEventListener("click", (event) => {
      const card = event.target.closest?.("product-card");
      if (!card || !root.contains(card)) {
        return;
      }
      const productId = productIdFromCard(card);
      rememberClick(productId, type);
      dataLayerPush("cart_reco_product_click", {
        cart_reco_type: type,
        product_id: productId,
      });
    });
  }

  function slideCategory(slide) {
    return (slide?.getAttribute("data-cart-reco-category") || "").toLowerCase();
  }

  function allowedTypes(root) {
    return parseIdList(root.getAttribute("data-cart-reco-allowed"));
  }

  function typeQuotas(types, display) {
    const n = Math.max(types.length, 1);
    const base = Math.floor(display / n);
    const extra = display % n;
    const quotas = {};
    types.forEach((type, index) => {
      quotas[type] = base + (index < extra ? 1 : 0);
    });
    return quotas;
  }

  function countCategories(root) {
    const counts = {};
    const seen = new Set();
    root.querySelectorAll(`.swiper-wrapper ${SLIDE_SELECTOR}`).forEach((slide) => {
      const id =
        slide.getAttribute("data-cart-reco-product-id") ||
        slide.querySelector("product-card")?.getAttribute("handle");
      if (!id || seen.has(id)) {
        return;
      }
      seen.add(id);
      const category = slideCategory(slide);
      if (!category) {
        return;
      }
      counts[category] = (counts[category] || 0) + 1;
    });
    return counts;
  }

  function categoryNeeded(root, category, remaining, options = {}) {
    if (remaining <= 0) {
      return false;
    }
    const unique = uniqueCount(root);
    if (unique >= displayCount(root)) {
      return false;
    }
    if (options.fillToDisplay) {
      return true;
    }
    const types = allowedTypes(root);
    if (!types.length) {
      return true;
    }
    if (!category || !types.includes(category)) {
      return Boolean(options.allowAnyType);
    }
    return true;
  }

  function missingQuota(root) {
    const types = allowedTypes(root);
    if (!types.length) {
      return 0;
    }
    const quotas = typeQuotas(types, displayCount(root));
    const counts = countCategories(root);
    return types.reduce(
      (sum, type) => sum + Math.max(0, (quotas[type] || 0) - (counts[type] || 0)),
      0,
    );
  }

  function interleaveWrappers(root) {
    const types = allowedTypes(root);
    if (types.length < 2) {
      return;
    }
    root.querySelectorAll(".swiper-wrapper").forEach((wrapper) => {
      const buckets = new Map(types.map((type) => [type, []]));
      const leftover = [];
      Array.from(wrapper.querySelectorAll(SLIDE_SELECTOR)).forEach((slide) => {
        const category = slideCategory(slide);
        if (buckets.has(category)) {
          buckets.get(category).push(slide);
        } else {
          leftover.push(slide);
        }
      });
      const ordered = [];
      let added = true;
      while (added) {
        added = false;
        types.forEach((type) => {
          const next = buckets.get(type)?.shift();
          if (next) {
            ordered.push(next);
            added = true;
          }
        });
      }
      leftover.forEach((slide) => ordered.push(slide));
      ordered.forEach((slide) => wrapper.appendChild(slide));
    });
  }

  function refreshSwipers(root) {
    root.querySelectorAll("[data-featured-collections-swiper]").forEach((el) => {
      if (el.swiper && typeof el.swiper.update === "function") {
        el.swiper.update();
        el.swiper.navigation?.update?.();
      }
    });
  }

  async function expandRoot(root) {
    if (root.dataset.cartRecoExpanded === "true" || root.dataset.cartRecoExpanding === "true") {
      if (root.dataset.cartRecoExpanded === "true") {
        interleaveWrappers(root);
      }
      return;
    }

    let remaining = Math.max(displayCount(root) - uniqueCount(root), 0);
    if (remaining <= 0) {
      root.dataset.cartRecoExpanded = "true";
      interleaveWrappers(root);
      return;
    }
    root.dataset.cartRecoExpanding = "true";

    const siteTypes = allowedTypes(root);
    const existing = new Set(
      parseIdList(root.getAttribute("data-cart-reco-handles")),
    );
    const wrappers = root.querySelectorAll(".swiper-wrapper");
    const typePools = parseTypePools(root);
    const fallbackHandle =
      root.getAttribute("data-cart-reco-fallback") || DEFAULT_FALLBACK;
    if (!wrappers.length) {
      delete root.dataset.cartRecoExpanding;
      root.dataset.cartRecoExpanded = "true";
      interleaveWrappers(root);
      return;
    }

    try {
    const parser = new DOMParser();

    async function ingestCollectionPages(
      handle,
      preferredCategory,
      options = {},
      maxPages = POOL_PAGES,
    ) {
      if (!handle || remaining <= 0) {
        return;
      }
      for (let page = 1; page <= maxPages && remaining > 0; page += 1) {
        try {
          const response = await fetch(collectionSectionUrl(handle, page), {
            credentials: "same-origin",
            headers: { Accept: "text/html" },
          });
          if (!response.ok) {
            break;
          }
          const doc = parser.parseFromString(await response.text(), "text/html");
          remaining = ingestSlides(
            root,
            doc,
            remaining,
            existing,
            wrappers,
            preferredCategory,
            options,
          );
          remaining = Math.max(displayCount(root) - uniqueCount(root), 0);
          const pages = Number(
            doc
              .querySelector("[data-cart-reco-search-pages]")
              ?.getAttribute("data-cart-reco-search-pages") || 1,
          );
          if (!pages || page >= pages) {
            break;
          }
        } catch {
          break;
        }
      }
    }

    for (const siteType of siteTypes) {
      remaining = Math.max(displayCount(root) - uniqueCount(root), 0);
      if (remaining <= 0) {
        break;
      }
      await ingestCollectionPages(typePools[siteType], siteType, {
        trustCollection: true,
      });
    }

    remaining = Math.max(displayCount(root) - uniqueCount(root), 0);
    if (remaining > 0 && fallbackHandle) {
      await ingestCollectionPages(
        fallbackHandle,
        "",
        { fillToDisplay: true, allowAnyType: true },
        FALLBACK_PAGES,
      );
    }

    const handles = Array.from(existing).filter((value) => Number.isNaN(Number(value)));
    root.setAttribute("data-cart-reco-handles", handles.join(","));
    remaining = Math.max(displayCount(root) - uniqueCount(root), 0);
    root.setAttribute("data-cart-reco-need", String(remaining));
    delete root.dataset.cartRecoExpanding;
    root.dataset.cartRecoExpanded = "true";
    interleaveWrappers(root);
    if (!root.querySelector("product-card")) {
      root.hidden = true;
      return;
    }
    root.hidden = false;
    refreshSwipers(root);
    bindAnalytics(root);
    } catch {
      delete root.dataset.cartRecoExpanding;
      root.dataset.cartRecoExpanded = "true";
    }
  }

  function boot(scope) {
    const roots = (scope || document).querySelectorAll?.(ROOT_SELECTOR);
    if (!roots) {
      return;
    }
    roots.forEach((root) => {
      bindAnalytics(root);
      expandRoot(root);
    });
  }

  document.addEventListener("cart:change", (event) => {
    if (event.detail?.baseEvent !== "variant:add") {
      return;
    }
    const items = event.detail.cart?.items || [];
    let clicked = {};
    try {
      clicked = JSON.parse(sessionStorage.getItem(CLICKED_KEY) || "{}");
    } catch {
      clicked = {};
    }
    items.forEach((item) => {
      const record = clicked[String(item.product_id)];
      if (!record) {
        return;
      }
      dataLayerPush("cart_reco_add_to_cart", {
        cart_reco_type: record.type,
        product_id: item.product_id,
        quantity: item.quantity,
      });
      delete clicked[String(item.product_id)];
    });
    try {
      sessionStorage.setItem(CLICKED_KEY, JSON.stringify(clicked));
    } catch {
      // Ignore storage errors.
    }
  });

  document.addEventListener("cart-drawer:refreshed", (event) => {
    const cartDrawer = event.target?.closest?.("cart-drawer") ?? event.target;
    boot(cartDrawer);
  });

  document.addEventListener(
    "dialog:after-show",
    (event) => {
      const cartDrawer = event.target?.closest?.("cart-drawer");
      if (cartDrawer) {
        boot(cartDrawer);
      }
    },
    true,
  );

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => boot(document));
  } else {
    boot(document);
  }
})();
